export default "__VITE_ASSET__CBEerIHf__"